<script lang="ts">
	import { onMount } from 'svelte';
	import { toast } from 'svelte-sonner';
	import { pwaInfo } from 'virtual:pwa-info';
	import * as m from '$lib/paraglide/messages';

	let registration: ServiceWorkerRegistration | undefined = $state(undefined);

	const webManifestLink = pwaInfo ? pwaInfo.webManifest.linkTag : '';

	onMount(async () => {
		if (!pwaInfo) return;

		const { registerSW } = await import('virtual:pwa-register');

		registerSW({
			immediate: true,
			onRegisteredSW(swScriptUrl: string, r?: ServiceWorkerRegistration) {
				registration = r;
			},
			onNeedRefresh() {
				toast(m.pwa_update_available(), {
					description: m.pwa_update_description(),
					action: {
						label: m.pwa_update_action(),
						onClick: () => {
							registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });
							navigator.serviceWorker.addEventListener('controllerchange', () => {
								window.location.reload();
							});
						}
					},
					duration: Infinity
				});
			}
		});
	});
</script>

<svelte:head>
	{@html webManifestLink}
</svelte:head>
